import { call, put, takeEvery } from "redux-saga/effects";
// import AXIOS_INSTANCE from "../../utils/USOBConfig";
import axios from "axios";
import AXIOS_INSTANCE from "../../utils/USOBConfig";

import {
  submitUserActivityActionDispatcher,
  SUBMIT_USER_ACTIVITY_ACTION_REQUESTED,
  submitUserActivityErrorDispatcher,
  GET_USER_ACTIVITY_ACTION_REQUESTED,
} from "./Action"; // Path should come here
import USOBApiRequest from "../../utils/ApiUrls";
import { getAuthUserDetails } from "../../utils/Helpers";
const postUserActivityAPI = async (postData) => {
  // console.log("postData: ", postData);
  // const result = await AXIOS_INSTANCE.get("/analytics", { ...postData });
  const result = await AXIOS_INSTANCE.post(`/analytics`, {
    ...postData,
  });
  
  return result;
};

const postGetUserActivityAPI = async (postData) => {

  const result= axios.get(USOBApiRequest.USOBApiBaseURL + `/analytics/user`, {
    headers: {
      "Content-Type": "text/plain",
      userid: getAuthUserDetails()?.usob_id,
      customerid: getAuthUserDetails()?.usob_cid,
      roleid: getAuthUserDetails()?.usob_rid,
    },
    params:postData,
   
  })
  
  return result;
};

function* submitUserActivitySaga({ postData }) {
  try {
    const data = yield call(postUserActivityAPI, postData);
    yield put(submitUserActivityErrorDispatcher({}));
  } catch (e) {
    yield put(submitUserActivityErrorDispatcher(e?.response?.data));
  }
}

function* getUserActivitySaga({ postData }) {
  try {
    const data = yield call(postGetUserActivityAPI, postData);
    yield put(submitUserActivityActionDispatcher(data));
    yield put(submitUserActivityErrorDispatcher({}));
  } catch (e) {
    yield put(submitUserActivityErrorDispatcher(e?.response?.data));
  }
}

function* submitUserActivityWatcher() {
  yield takeEvery(
    SUBMIT_USER_ACTIVITY_ACTION_REQUESTED,
    submitUserActivitySaga
  );
  yield takeEvery(GET_USER_ACTIVITY_ACTION_REQUESTED, getUserActivitySaga);
}
export default submitUserActivityWatcher;
